















import { Vue, Component } from "@/shared/vuepack";
import { Home } from "@/employee/route-names";
import { useBalanceTransferStore } from "@/employee/store/balanceTransfer";
import Button from "@/shared/components/ui/Button.vue";

@Component({
  components: {
    Button
  }
})
export default class Finish extends Vue {
  balanceTransferStore = useBalanceTransferStore();

  get buttonText () {
    return this.balanceTransferStore.isOnboarding ? "Go to dashboard" : "Done";
  }

  onFinish () {
    this.balanceTransferStore.clearState();

    if (this.balanceTransferStore.isOnboarding) {
      this.$router.push({ name: Home });
    } else {
      this.balanceTransferStore.goToStart();
    }
  }
}
